import { AssetTag } from '@gripp/shared-logic';
import { ReactNode } from 'react';

export type AssetTagGalleryProps = {
  existingAssetTags: AssetTag[];
  onAssetTagAdded: (assetTag: AssetTag) => void;
  onAssetTagDeleted: (assetTagId: string) => void;
  tagPicker?: TagPickerComponent;
  editable?: boolean;
  /**
   * When provided, the QR icon on each tag becomes pressable and invokes this
   * callback with the tag. Used on web to open a panel that renders the tag
   * as its printed Gripp Tag. Omit to keep the icon non-interactive.
   */
  onViewTagQr?: (assetTag: AssetTag) => void;
};

export type TagPickerProps = {
  setTag: (tag: any) => void;
  setAlertTitle?: (title: string) => void;
  setShowAlert?: (visible: boolean) => void;
};

export type TagPickerComponent = (props: TagPickerProps) => ReactNode;
